// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
// normalize CSS across browsers
import "./src/styles/normalize.css"
// custom CSS styles
import "./src/styles/style.css"

// Highlighting for code blocks
import "./src/styles/prism/one-dark.css"
import "prismjs/plugins/line-numbers/prism-line-numbers.css"
import "prismjs/plugins/command-line/prism-command-line.css"

import * as React from 'react'
import { CacheProvider } from '@emotion/react'
import { MDXProvider } from '@mdx-js/react'
import createEmotionCache from './src/utils/createEmotionCache'
import shortcodes from './src/components/MdxComponents'

const clientSideEmotionCache = createEmotionCache()

export const wrapRootElement = ({ element }) => {
	return (
		<CacheProvider value={clientSideEmotionCache}>
			<MDXProvider components={shortcodes}>
				{element}
			</MDXProvider>
		</CacheProvider>
	)
}
